<script>
import { mapGetters } from 'vuex';
import LayoutWeb from '@/components/LayoutWeb.vue';
import LayoutMobile from '@/components/LayoutMobile.vue';
import Snackbar from '@/components/Snackbar.vue';

// const LayoutMobile = () =>
//   import(
//     /* webpackChunkName: "layoutMobile" */ /* webpackPreload: true */ '@/components/LayoutMobile.vue'
//   );
// const LayoutWeb = () =>
//   import(
//     /* webpackChunkName: "layoutWeb" */ /* webpackPreload: true */ '@/components/LayoutWeb.vue'
//   );
const LayoutApp = () =>
  import(
    /* webpackChunkName: "layoutApp" */ /* webpackPrefetch: true */ '@/components/LayoutApp.vue'
  );

// import LayoutApp from '@/components/LayoutApp.vue';

export default {
  name: 'App',

  components: {
    LayoutApp,
    LayoutWeb,
    LayoutMobile,
    Snackbar,
  },

  computed: {
    ...mapGetters('ui', ['layout']),
  },

  watch: {
    $route: {
      handler: 'getRoute',
      immediate: true,
    },
  },

  created() {
    window.addEventListener('beforeinstallprompt', e => {
      console.log('Stashing installPrompt');
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.$store.dispatch('sw/updateInstallPrompt', e);
    });

    window.addEventListener('appinstalled', () => {
      console.log('PWA installed');
      // Only relevant if clicked button from prompt
      // this.$store.commit('sw/setAcceptedInstallPrompt', true);
      this.$store.dispatch('analytics/acceptAddToHomeScreen');
    });
  },

  methods: {
    getRoute() {
      const { $store, $route } = this;
      // console.log($route);
      $store.dispatch('ui/parseRoute', $route);
      const appContainer = document.getElementById('main-app-container');
      if (appContainer) {
        appContainer.scrollTop = 0;
      }
    },
  },
};
</script>

<template>
  <div id="app" :class="$mq">
    <div v-if="layout === 'app'">
      <LayoutApp />
    </div>
    <div v-else>
      <mq-layout mq="lg+">
        <LayoutWeb />
      </mq-layout>

      <mq-layout :mq="['sm', 'md']">
        <LayoutMobile />
      </mq-layout>
    </div>

    <Snackbar />
  </div>
</template>

<style lang="scss"></style>
